// extracted by mini-css-extract-plugin
export default {"info":"style_info__5T6Yf","info__col":"style_info__col__cX1+Y"};